
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-library/[videoslug]",
      function () {
        return require("private-next-pages/video-library/[videoslug].js");
      }
    ]);
  